import React from "react";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { FaPlus } from "react-icons/fa";

import ConditionText from "./ConditionText";
import ConditionCity from "./ConditionCity";
import ConditionState from "./ConditionState";
import ConditionSelect from "./ConditionSelect";
import ConditionComplete from "./ConditionComplete";
import ConditionDate from "./ConditionDate";
import ConditionNumber from "./ConditionNumber";
import FieldController from "../../../controller/FieldController";
import Const from "../../../util/Constants";
import Util from "../../../util/Util";

class MainCondition extends React.Component {
  constructor(props) {
    super(props);
    const fields = props.fields;
    this.fieldList = [];
    for (let i = 0; fields && i < fields.length; i++) {
      this.fieldList.push({
        id: fields[i].id,
        value: fields[i].fieldKey,
        type: fields[i].field_type,
        label: fields[i].label_name,
      });
    }

    const conditions = [];
    this.value = {
      show: false,
      field: "",
      condition: "",
      conditions,
      text: "",
      fOpt: "",
      select: "",
      from: "",
      to: "",
      andor: false,
    };

    let filters = [];
    if (props.value) {
      filters = this.getConditions(props.value);
    }
    this.state = { ...this.state, filters };
    if (this.props.onConditionChanged) {
      this.props.onConditionChanged(filters);
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    const fields = props.fields;
    this.fieldList = [];
    for (let i = 0; fields && i < fields.length; i++) {
      this.fieldList.push({
        id: fields[i].id,
        value: fields[i].fieldKey,
        type: fields[i].field_type,
        label: fields[i].label_name,
      });
    }
    const filters = this.getConditions(props.value);
    this.setState({ ...this.state, filters });
    if (this.props.onConditionChanged) {
      this.props.onConditionChanged(filters);
    }
    this.isComponentUpdate = true;
  }

  getConditions = (value) =>
    value.map((value) => {
      const field = this.fieldList.find((field) => field.value === value.field);
      if (field === undefined) return { ...value };
      const conditions = FieldController.getConditions(field.type, field.value);
      const condition = conditions.find(
        (condition) => condition.value === value.condition
      );
      const fOpt = this.getOptionField(field.type, value.condition);
      const options = this.getOptions(fOpt, field.value, value.value);
      const andor = value.andor ? value.andor : false;
      value = value.value;
      return {
        field,
        condition,
        conditions,
        value,
        ...fOpt,
        ...options,
        andor,
      };
    });

  getOptionField = (type, condition) => {
    const isText = FieldController.showTextFilter(type, condition);
    const isFrom = FieldController.showDateFrom(type, condition);
    const isTo = FieldController.showDateTo(type, condition);
    const isCity = FieldController.showCity(type, condition);
    const isState = FieldController.showState(type, condition);
    const isCountry = FieldController.showCountry(type, condition);
    const isSelect = FieldController.showSelect(type, condition);
    return { isText, isFrom, isTo, isCity, isState, isCountry, isSelect };
  };

  getOptions = (fOpt, field, value) => {
    if (!value) value = "";
    let select = "",
      options = [],
      from = null,
      to = null;
    if (fOpt.isCity) {
      options = FieldController.getOptions({ field_type: Const.City });
      select = options.filter((option) => value.includes(`~${option.value}~`));
    } else if (fOpt.isState) {
      options = FieldController.getOptions({ field_type: Const.State });
      select = options.filter((option) => value.includes(`~${option.value}~`));
    } else if (fOpt.isCountry) {
      options = FieldController.getOptions({ field_type: Const.Country });
      select = options.filter((option) => value.includes(`~${option.value}~`));
    } else if (fOpt.isSelect) {
      options = FieldController.getOptions(this.props.model.fields[field]);
      select = options.filter((option) => value.includes(`~${option.value}~`));
    } else if (fOpt.isFrom || fOpt.isTo) {
      if (value !== "") {
        const dates = value.split(Const.Opt);
        from = Util.serverStringDateTimeToDate(dates[0]);
        to = Util.serverStringDateTimeToDate(dates[1]);
      }
    }
    return { select, options, from, to };
  };

  onAdd = (field) => {
    const filters = [...this.state.filters, { ...this.value }];
    const i = filters.length - 1;
    const conditions = FieldController.getConditions(
      field.type,
      field ? field.value : ""
    );
    filters[i] = { ...this.value, field: field, conditions };
    this.props.onConditionChanged(filters);
    this.setState({ ...this.state, filters: [...filters], show: false });
  };
  onDelete = (index) => {
    let filters = [...this.state.filters];
    filters = filters.filter((_, i) => i !== index);
    this.props.onConditionChanged(filters);
    this.setState({ ...this.state, filters: [...filters] });
  };

  onFilterChanged = (i, filter) => {
    const filters = [...this.state.filters];
    filters[i] = filter;
    this.props.onConditionChanged(filters);
    this.setState({ ...this.state, filters: [...filters] });
  };

  onConditionChanged = (i, con) => {
    const filters = [...this.state.filters];
    const fOpt = this.getOptionField(
      filters[i].field.type,
      con ? con.value : ""
    );
    const options = this.getOptions(
      fOpt,
      filters[i].field.value,
      filters[i].value
    );
    filters[i] = {
      ...filters[i],
      condition: con,
      ...fOpt,
      ...options,
      andor: false,
    };
    this.props.onConditionChanged(filters);
    this.setState({ ...this.state, filters: [...filters] });
  };
  onSelect = (i, select) => {
    const value =
      select === null
        ? ""
        : Array.isArray(select)
        ? `~${select.map((val) => val.value).join("~")}~`
        : `~${select.value}~`;
    const filters = [...this.state.filters];
    filters[i] = { ...filters[i], select: select, value };
    this.props.onConditionChanged(filters);
    this.setState({ ...this.state, filters: [...filters] });
  };

  handleDateChange = (i, source, date) => {
    const filters = [...this.state.filters];
    let value = "";
    const from = filters[i].from;
    const to = filters[i].to;
    if (source === "from" && date !== null && to !== null) {
      value = `${Util.dateToServerDateTime(date)}${
        Const.Opt
      }${Util.dateToServerDateTime(to)}`;
    } else if (source === "from" && date !== null && to === null) {
      value = `${Util.dateToServerDateTime(date)}${Const.Opt}`;
    } else if (source === "from" && date === null && to !== null) {
      value = `${Util.dateToServerDateTime(date)}${
        Const.Opt
      }${Util.dateToServerDateTime(to)}`;
    } else if (source === "to" && from !== null && date !== null) {
      value = `${Util.dateToServerDateTime(from)}${
        Const.Opt
      }${Util.dateToServerDateTime(date)}`;
    } else if (source === "to" && from !== null && date === null) {
      value = `${Util.dateToServerDateTime(from)}${Const.Opt}`;
    } else if (source === "to" && from === null && date !== null) {
      value = `${Const.Opt}${Util.dateToServerDateTime(date)}`;
    }

    if (source === "from") filters[i] = { ...filters[i], value, from: date };
    else filters[i] = { ...filters[i], value, to: date };
    this.props.onConditionChanged(filters);
    this.setState({ ...this.state, filters: [...filters] });
  };

  onCondition = (i, andor) => {
    const filters = [...this.state.filters];
    filters[i].andor = andor;
    this.props.onConditionChanged(filters);
    this.setState({ ...this.state, filters: [...filters] });
  };

  render() {
    return (
      <>
        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          size="md"
          className="w-660"
          centered
          show={this.state.show}
          onHide={() => this.setState({ ...this.state, show: false })}
          onExit={() => this.setState({ ...this.state, show: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Add Field
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Select
              className="mr-sm-2"
              onChange={(selected) => this.onAdd(selected)}
              options={this.fieldList}
              isSearchable={true}
              isClearable={true}
            />
          </Modal.Body>
        </Modal>
        <div className="formhead col-md-12">
          <h4>
            {this.props.title ? this.props.title : `Condition`}
            &nbsp;&nbsp;
            <Button
              variant="primary"
              onClick={() => this.setState({ ...this.state, show: true })}
            >
              <FaPlus />
            </Button>
          </h4>
        </div>

        {this.state.filters.map((filter, i) => {
          const type = filter.field?.type;
          if (type === undefined) return;
          if (
            type === Const.Text ||
            type === Const.TextArea ||
            type === Const.MultiValue ||
            type === Const.Street ||
            type === Const.Pin ||
            type === Const.Phone ||
            type === Const.Email
          ) {
            return (
              <ConditionText
                key={`filter_${i}`}
                index={i}
                filter={filter}
                onFilterChanged={this.onFilterChanged}
                onDelete={this.onDelete}
              />
            );
          } else if (type === Const.City) {
            return (
              <ConditionCity
                key={`filter_${i}`}
                index={i}
                filter={filter}
                onFilterChanged={this.onFilterChanged}
                onDelete={this.onDelete}
              />
            );
          } else if (type === Const.State) {
            return (
              <ConditionState
                key={`filter_${i}`}
                index={i}
                filter={filter}
                fields={this.props.model.fields}
                onFilterChanged={this.onFilterChanged}
                onDelete={this.onDelete}
              />
            );
          } else if (type.includes(Const.Select) || type === Const.Status) {
            return (
              <ConditionSelect
                key={`filter_${i}`}
                index={i}
                filter={filter}
                fields={this.props.model?.fields}
                onFilterChanged={this.onFilterChanged}
                onDelete={this.onDelete}
              />
            );
          } else if (type.includes(Const.Complete)) {
            return (
              <ConditionComplete
                key={`filter_${i}`}
                index={i}
                filter={filter}
                fields={this.props.model?.fields}
                onFilterChanged={this.onFilterChanged}
                onDelete={this.onDelete}
              />
            );
          } else if (type.includes(Const.Date)) {
            return (
              <ConditionDate
                key={`filter_${i}`}
                index={i}
                filter={filter}
                onFilterChanged={this.onFilterChanged}
                onDelete={this.onDelete}
              />
            );
          } else if (
            type.includes(Const.Number) ||
            type.includes(Const.Decimal) ||
            type.includes(Const.Duration)
          ) {
            return (
              <ConditionNumber
                key={`filter_${i}`}
                index={i}
                filter={filter}
                onFilterChanged={this.onFilterChanged}
                onDelete={this.onDelete}
              />
            );
          } else {
            return null;
          }
        })}
      </>
    );
  }
}
export default MainCondition;
